export const INCLUDED = 'included'
export const EXCLUDED = 'excluded'
export const ONLY = 'only'

type TS_INCLUDED = typeof INCLUDED
type TS_EXCLUDED = typeof EXCLUDED
type TS_ONLY = typeof ONLY

export type TS_FILTER = TS_INCLUDED | TS_EXCLUDED | TS_ONLY